import { create } from "zustand";

interface RevenueEachStoreState {
  accountId: any;
  startDate: any;
  endDate: any;
  monthSelect: any;
  setMonthSelect: (monthSelect: any) => void;
  setAccountId: (accountId: any) => void;
  setStartDate: (startDate: string) => void;
  setEndDate: (endDate: string) => void;
}

export const useRevenueEachStore = create<RevenueEachStoreState>((set) => ({
  accountId: null,
  startDate: null,
  endDate: null,
  monthSelect: undefined,
  setAccountId: (accountId) => set({ accountId }),
  setStartDate: (startDate) => set({ startDate }),
  setEndDate: (endDate) => set({ endDate }),
  setMonthSelect: (monthSelect) => set({ monthSelect }),
}));
